import { Col, Row } from 'reactstrap';
import PeriodoData from 'src/paginas/data/periodo-data';

const GraficoScoreRiscoSearch = ({ model }) => {
  const handleChangeFiltro = (field, value) => {
    model.getModel(field).requestChange(value);
  };

  return (
    <div style={{ minWidth: 1000 }}>
      <Row>
        <Col md={12}>
          <PeriodoData
            clearable
            tipoFiltroData={model.getModel('tipoFiltroData').value}
            dataInicio={model.getModel('dataInicio').value}
            dataTermino={model.getModel('dataTermino').value}
            onChange={handleChangeFiltro}
          />
        </Col>
      </Row>
    </div>
  );
};

export default GraficoScoreRiscoSearch;
